import { LoginMethod } from '@viamrobotics/web-client/app/v1/app';

/** A selectable organization login method paired with its display label. */
export interface LoginMethodOption {
  value: LoginMethod;
  label: string;
}

/**
 * The login methods an organization can restrict access to, in display order.
 * Excludes {@link LoginMethod.UNSPECIFIED}, which is not a real method.
 */
export const LOGIN_METHOD_OPTIONS: LoginMethodOption[] = [
  { value: LoginMethod.PASSWORD, label: 'Password' },
  { value: LoginMethod.GOOGLE, label: 'Google' },
  { value: LoginMethod.GITHUB, label: 'GitHub' },
  { value: LoginMethod.APPLE, label: 'Apple' },
];

const LOGIN_METHOD_LABELS = new Map<LoginMethod, string>(
  LOGIN_METHOD_OPTIONS.map(({ value, label }) => [value, label])
);

/** Returns a human-readable label for a login method. */
export const formatLoginMethod = (method: LoginMethod): string =>
  LOGIN_METHOD_LABELS.get(method) ?? 'Unknown';
